import { servicesQuery } from '@/services/api';
import type { UseTasksOptions } from '../types';
import { transformBackfill } from '../utils/task-transform';

export function useTasks(options: UseTasksOptions) {
  const { workspaceId, continuation, limit, enabled = true, state, type, refetchInterval } = options;

  const { data, isLoading, refetch, dataUpdatedAt } = servicesQuery.getBackfills.useQuery({
    queryKey: ['backfills', workspaceId, continuation, state, type],
    queryData: {
      params: { environment_id: workspaceId ?? 0 },
      query: {
        continuation: continuation ?? undefined,
        state: state ?? undefined,
        type: type ?? undefined,
      },
    },
    enabled: enabled && workspaceId != null && workspaceId > 0,
    refetchInterval,
    select: (queryData) => {
      return {
        ...queryData,
        body: { ...queryData.body, backfills: (queryData.body?.backfills ?? [])?.map(transformBackfill) },
      };
    },
  });

  // Apply limit after select to avoid unnecessary refetches when limit changes
  const tasks = (limit != null && limit > 0 ? data?.body.backfills.slice(0, limit) : data?.body.backfills) ?? [];

  return {
    tasks,
    meta: data?.body.meta,
    isLoading,
    refetch,
    dataUpdatedAt,
  };
}
